import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KReportWidget";
var classes = {
    class1: "".concat(PREFIX, "-main")
};
var StyledKReportWidget = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "backgroundColor"; }
})(function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return ({
        zIndex: 1,
        position: "relative",
        height: "100%",
        width: "100%",
        backgroundColor: backgroundColor || theme.palette.primary.main
    });
});

export { classes, StyledKReportWidget as default };
//# sourceMappingURL=index.styled.js.map
